"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_VIEW_RECIBIDOS_COLUMNS_MAP = void 0;
exports.SORTABLE_VIEW_RECIBIDOS_COLUMNS_MAP = {
    id: 'smsin_id',
    origen: 'smsin_from',
    destino: 'smsin_numero',
    mensaje: 'smsin_content',
    recibido: 'smsin_receivedtime',
    fecha: 'fecha',
};
